/* Suppresses the Sell Easy "Vaak samen gekocht" popup when add-to-cart
   originates from the upsell ("Maak je bestelling compleet") section
   or the quick-view ("Meer info") modal.

   SAFE VERSION (no broad scanning, no DOM removal):
   1. Forms in those sections set window.__suppressCartPopupOnce = true.
   2. A MutationObserver watches document.body for newly-added nodes
      matching SELL_EASY_SELECTORS only. Matching nodes are hidden via
      CSS (display:none !important) — never removed from the DOM, never
      pointer-events disabled, never selected by text content.
   3. Flag auto-clears after 4s.

   Why this is safe:
   - We only match nodes that match very specific Sell Easy selectors.
   - We do not scan or modify the cart drawer, cart notification, or any
     theme element.
   - We do not call preventDefault on any event.

   Tuning:
   If the popup is still appearing, the selectors below are likely missing
   the actual Sell Easy markup. Open DevTools when the popup shows, copy
   the popup's outermost element selector, and add it to SELL_EASY_SELECTORS.
   Until tuned, the popup may still appear — that is preferred over breaking
   anything else. */

(function () {
  /* Sell Easy renders the "Vaak samen gekocht" popup with `lb-` prefixed
     classes (e.g., .lb-popup-cont-head-title for the modal title). The
     outermost overlay/container also carries this prefix, so matching
     [class*="lb-popup"] reliably catches the whole popup tree. */
  var SELL_EASY_SELECTORS = [
    '[class*="lb-popup"]',
    '[class*="lb-modal"]',
    '[class*="lb-overlay"]',
    '[id*="lb-popup"]',
    '[id*="selleasy" i]',
    '[class*="selleasy" i]',
    '[id*="sell-easy" i]',
    '[class*="sell-easy" i]',
    'iframe[src*="selleasy"]',
    'iframe[src*="sell-easy"]',
  ].join(',');

  var FORM_SELECTORS = [
    'product-form.upsell-add form',
    '.akta-quickview-content product-form form',
    '.akta-quick-view-modal product-form form',
  ].join(',');

  var FLAG_TIMEOUT_MS = 4000;
  var flagTimer = null;

  window.__suppressCartPopupOnce = false;

  function hideExistingMatches() {
    /* One-shot: hide any popup elements that are already in the DOM
       (covers the case where Sell Easy pre-renders hidden and toggles
       visibility instead of injecting fresh nodes). */
    try {
      var existing = document.querySelectorAll(SELL_EASY_SELECTORS);
      for (var i = 0; i < existing.length; i++) {
        hideNode(existing[i]);
      }
    } catch (e) {
      /* ignore */
    }
  }

  function setSuppressFlag() {
    window.__suppressCartPopupOnce = true;
    if (flagTimer) clearTimeout(flagTimer);
    flagTimer = setTimeout(function () {
      window.__suppressCartPopupOnce = false;
      flagTimer = null;
    }, FLAG_TIMEOUT_MS);
    hideExistingMatches();
    /* Run a few additional scans during the flag window to catch popups
       that are added with a slight delay (e.g., after the /cart/add fetch
       resolves). Limited to 4 attempts to stay cheap. */
    setTimeout(hideExistingMatches, 100);
    setTimeout(hideExistingMatches, 400);
    setTimeout(hideExistingMatches, 1000);
    setTimeout(hideExistingMatches, 2000);
  }

  function clearSuppressFlag() {
    window.__suppressCartPopupOnce = false;
    if (flagTimer) {
      clearTimeout(flagTimer);
      flagTimer = null;
    }
  }

  function hideNode(node) {
    try {
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('data-suppressed-cart-popup', '1');
    } catch (e) {
      /* ignore */
    }
  }

  function checkAndSuppress(node) {
    if (!node || node.nodeType !== 1) return false;
    try {
      if (node.matches && node.matches(SELL_EASY_SELECTORS)) {
        hideNode(node);
        return true;
      }
      if (node.querySelector) {
        var match = node.querySelector(SELL_EASY_SELECTORS);
        if (match) {
          hideNode(match);
          return true;
        }
      }
    } catch (e) {
      /* invalid selector or matches() unsupported — skip */
    }
    return false;
  }

  function attachObserver() {
    if (!('MutationObserver' in window)) return;
    var observer = new MutationObserver(function (mutations) {
      if (!window.__suppressCartPopupOnce) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added) continue;
        for (var j = 0; j < added.length; j++) {
          if (checkAndSuppress(added[j])) {
            clearSuppressFlag();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function attachFormListeners() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches) return;
        try {
          if (form.matches(FORM_SELECTORS)) {
            setSuppressFlag();
          }
        } catch (e) {
          /* ignore */
        }
      },
      true
    );
  }

  function init() {
    attachFormListeners();
    if (document.body) {
      attachObserver();
    } else {
      document.addEventListener('DOMContentLoaded', attachObserver);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
